module.exports = " <div class=row> <div ui-view=indicators@></div> <div ui-view=principal@></div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/u-faculty/workplan/start/index.html
// module id = 571
// module chunks = 0